import { Link } from 'react-router-dom';

export default function OperationsSection() {
  return (
    <section className="sec g">
      <div className="wrap">
        <div className="hd2 rv">
          <div>
            <small>기업의 AI 도입에 필요한 조건</small>
            <h2>
              기업 환경에 맞춘
              {' '}
              <em>AI 운영·관리</em>
            </h2>
          </div>
          <Link className="more" to="/product#s6">
            자세히보기
            <svg className="i">
              <use href="#arr" />
            </svg>
          </Link>
        </div>
        <div className="who3">
          <div className="bc hasgo gs rv">
            <div className="t">
              <svg className="i">
                <use href="#shield" />
              </svg>
              AI 인프라 준비 부담 줄이기
            </div>
            <p>Amazon Bedrock을 활용한 AI 인프라 구성</p>
            <div className="ill nc" style={{ height: "220px" }}>
              <div className="ui hl" style={{ left: "50%", top: "70px", width: "190px", marginLeft: "-95px", padding: "16px", display: "flex", alignItems: "center", gap: "10px" }}>
                <img src="/site/logos/aws.svg" alt="" style={{ width: "30px" }} />
                <div>
                  <div style={{ fontSize: "14px", fontWeight: "800" }}>Amazon Bedrock</div>
                  <div style={{ fontSize: "11px", color: "var(--t4)" }}>AI 인프라</div>
                </div>
              </div>
              <span className="lg" style={{ left: "6%", top: "6px" }}>
                <img src="/site/logos/anthropic.svg" alt="" />
              </span>
              <span className="lg" style={{ right: "8%", top: "14px" }}>
                <img src="/site/logos/openai.svg" alt="" />
              </span>
              <span className="lg" style={{ left: "14%", top: "160px" }}>
                <img src="/site/logos/gemini.svg" alt="" />
              </span>
              <span className="lg" style={{ right: "12%", top: "150px" }}>
                <img src="/site/logos/naver.svg" alt="" />
              </span>
            </div>
          </div>
          <div className="bc hasgo gp rv d1">
            <div className="t">
              <svg className="i">
                <use href="#quote" />
              </svg>
              답변 근거까지 확인
            </div>
            <p>출처 문서와 관련 내용을 보고 답변 근거 확인</p>
            <div className="ill" style={{ height: "220px" }}>
              <div className="ui" style={{ left: "0", right: "0", top: "8px" }}>
                <div className="cite">
                  <mark>사내 규정에서 필요한 내용</mark>
                  을 찾아 안내합니다.
                  <sup>1</sup>
                </div>
              </div>
              <div className="ui hl" style={{ left: "30px", right: "0", top: "144px" }}>
                <div className="doc">
                  <span className="fi">PDF</span>
                  <div>
                    <b>출처 · 사내 업무 매뉴얼</b>
                    <span>관련 내용 보기</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bc hasgo gm rv d2">
            <div className="t">
              <svg className="i">
                <use href="#chart" />
              </svg>
              운영 현황을 한눈에 확인
            </div>
            <p>워크플로우·지식베이스 통계와 최근 작업 내역을 대시보드에서 확인</p>
            <div className="ill" style={{ height: "220px" }}>
              <div className="ui" style={{ left: "0", top: "8px", width: "170px" }}>
                <div className="kpi">
                  <small>
                    <span className="dt" style={{ background: "var(--ac)" }} />
                    내 워크플로우
                  </small>
                  <b>
                    12
                    <em>개</em>
                  </b>
                  <div className="pr">
                    <i style={{ width: "60%", background: "var(--ac)" }} />
                  </div>
                </div>
              </div>
              <div className="ui" style={{ left: "110px", right: "0", top: "52px" }}>
                <div className="kpi">
                  <small>
                    <span className="dt" style={{ background: "var(--teal)" }} />
                    지식베이스
                  </small>
                  <b>
                    8
                    <em>개</em>
                  </b>
                  <div className="pr">
                    <i style={{ width: "40%", background: "var(--teal)" }} />
                  </div>
                </div>
              </div>
              <div className="ui log" style={{ left: "0", right: "0", top: "150px" }}>
                <div className="r2" style={{ borderTop: "0" }}>
                  <span className="dt" style={{ background: "var(--grn)" }} />
                  <b>최근 작업 내역</b>
                  <span className="bdg g">성공</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
